import React, { useState } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import { useStyles } from './styles';

import CountryCodeList from './countryCodeList';
import DownIcon from '@material-ui/icons/ArrowDropDown';
import useCountryCodeUIState from './useCountryCodeUIState';
import { useUserStore } from '../../store/models';

function MobileInput ({
    onChange = () => {},
    value = {},
    className,
    label = 'Phone number',
    helperText = 'Phone number',
    error = false,
    placeHolderText = 'Phone number',
}) {

    const userStore = useUserStore();

    const {
        openList,
        listAnchor,
        country,
        countryCode,
        openCountryCodeList,
        closeCountryCodeList,
        selectCountryCode,
        codeIndex,
        onPhoneKeyDown,
        phoneNumber,
        setPhoneNumber,
    } = useCountryCodeUIState({
        value,
        geoCountry: userStore.countryInfo?.country,
    });

    const [focused, setFocused] = useState(false);

    const classes = useStyles({
        error,
        helperText,
    });

    return (
        <React.Fragment>
            <TextField
                id="phone-input"
                label={label}
                variant="outlined"
                name="mobile"
                fullWidth
                value={phoneNumber}
                onChange={(e) => {
                    setPhoneNumber(e.target.value);
                    if (typeof onChange === 'function') {
                        onChange({
                            countryCode,
                            phoneNumber: e.target.value,
                            value: countryCode + e.target.value,
                            codeIndex,
                            country,
                        });
                    }
                }}
                onBlur={(e) => {
                    setFocused(false);
                    if (typeof onChange === 'function') {
                        onChange({
                            countryCode,
                            phoneNumber: e.target.value,
                            value: countryCode + e.target.value,
                            codeIndex,
                            country,
                        });
                    }
                }}
                onFocus={() => setFocused(true)}
                onKeyDown={onPhoneKeyDown}
                helperText={helperText}
                error={error}
                placeholder={focused ? '' : placeHolderText}
                className={classNames(['ecal-reg-field-mobile', className])}
                inputProps={{ autoComplete: 'off' }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Button
                                className={classes.button}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    openCountryCodeList({ anchor: e.target });
                                }}
                                data-ecal-id='flagPicker'
                            >
                                <span className={classNames([
                                    classes.flags,
                                    classes[`flag_${country}`],
                                ])} />
                                <span className={classes.listItemCode}>
                                    +{countryCode}
                                </span>
                                <DownIcon
                                    size="small"
                                    className={classes.downIcon}
                                />
                            </Button>
                        </InputAdornment>
                    ),
                }}
            />

            <CountryCodeList
                open={openList}
                anchorEl={listAnchor}
                onCloseList={() => closeCountryCodeList()}
                onItemClick={(p) => {
                    selectCountryCode(p);
                    onChange({
                        codeIndex: p.index,
                        countryCode: p.data.code,
                        country: p.data.iso2,
                        phoneNumber,
                        value:  p.data.code + phoneNumber,
                    });
                    closeCountryCodeList();
                }}
                selectedCodeIndex={codeIndex}
                country={country}
            />

        </React.Fragment>
    );
}

MobileInput.propTypes = {
    label: PropTypes.string,
    helperText: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.any,
    error: PropTypes.bool,
    placeHolderText: PropTypes.string,
};

export default observer(MobileInput);
